import {useState} from "react";
import Button from "../button/button.jsx";
import {FaEye} from "react-icons/fa";
import AttachShow from "../attach/attach-show.jsx";

export default function CellRendererAttachButton({ attachId, modalTitle }) {
    const [openModal, setOpenModal] = useState(false);
    const [file, setFile] = useState(null);

    return (
        <>
            <div className="w-full h-full flex justify-center items-center">
                {attachId && (
                    <Button
                        className="h-[30px]! w-[30px]! p-[0]!"
                        title="Visualizar anexo"
                        onClick={() => setOpenModal(true)}
                    >
                        <FaEye />
                    </Button>
                )}
            </div>
            <AttachShow
                file={file}
                setFile={setFile}
                attachId={attachId}
                open={openModal}
                setOpen={setOpenModal}
                showRemove={false}
                modalTitle={modalTitle}
            />
        </>
    )
}